/**
 * LOYALTY MANAGER JS FINAL
 */

(function() {
    async function initLoyaltyManager() {

        const globalLoader = document.getElementById('global-page-loader');
        const loginScreen = document.getElementById('login-required');
        const dashboard = document.getElementById('club-dashboard-content');

        const userEmail = window.ShopifyUserEmail;

        if (!userEmail || userEmail === '') {
            console.warn("⚠️ No hay usuario logueado.");

            if (window.Shopify && window.Shopify.designMode) {
                console.info("🎨 Shopify design mode detectado. Se omite el redirect a /pages/club-brillo-login.");
                if (globalLoader) {
                    globalLoader.innerHTML = `
                        <div class="loader-text" style="padding:24px; text-align:center;">
                            <p style="font-weight:600; margin-bottom:8px;">Club Brillo (vista previa del editor)</p>
                            <p style="font-size:0.9rem; color:#666;">Inicia sesión como cliente en la storefront para ver el dashboard real.</p>
                        </div>
                    `;
                }
                return;
            }

            window.location.href = '/pages/club-brillo-login';
            return;
        }

        try {
            const userData = await fetchAPI('user-info', { email: userEmail });
            
            if (!userData || !userData.id) {
                throw new Error("No encontramos una cuenta activa en el Club.");
            }
            const userId = userData.id;
            window.GlobalClubUserId = userData.id;
            const nameEl = document.getElementById('user-name');
            const pointsEl = document.getElementById('user-points');
            const totalPointsEl = document.getElementById('user-points-total');

            if(nameEl && userData.first_name) nameEl.textContent = userData.first_name;
            if(pointsEl) pointsEl.textContent = userData.reward_score;
            
           const [tierDataUser, tierStructure] = await Promise.all([
                fetchAPI('current-tier', { user_id: userId }),
                fetchAPI('tiers-list')
            ]);

            // Inyección de Puntos Totales desde tierDataUser.tiers[0].value
            if (totalPointsEl && tierDataUser && tierDataUser.tiers && tierDataUser.tiers.length > 0) {
                totalPointsEl.textContent = tierDataUser.tiers[0].value !== undefined 
                    ? tierDataUser.tiers[0].value 
                    : 0;
            }
            // 1. Corrección de la barra: Usar puntos del periodo actual
            const currentPeriodPoints = userData.current_period_score !== undefined ? userData.current_period_score : userData.reward_score;
            const currentPoints = processHeroSection(tierDataUser, tierStructure, currentPeriodPoints);

            // 2. Inyección de fechas
            const lastPurchaseEl = document.getElementById('user-last-purchase');
            const tierExpEl = document.getElementById('user-tier-expiration');
            const tierDaysLeftEl = document.getElementById('user-tier-days-left');

            if (lastPurchaseEl && userData.national_identity) {
                try {
                    const lastSaleData = await fetchAPI('last-sale', { dni: userData.national_identity }, 'GET');
                    const purchaseDate = lastSaleData ? lastSaleData.last_purchase_date : null;

                    lastPurchaseEl.textContent = purchaseDate 
                        ? new Date(purchaseDate).toLocaleDateString('es-PE', { year: 'numeric', month: '2-digit', day: '2-digit' }) 
                        : 'Aún no has realizado una compra';
                } catch (e) {
                    console.warn("⚠️ No se pudo obtener la última compra:", e);
                    lastPurchaseEl.textContent = 'Aún no has realizado una compra';
                }
            }

            // Cálculo dinámico de días y fecha de vencimiento
            if (tierDataUser.tiers && tierDataUser.tiers.length > 0) {
                const expDateRaw = tierDataUser.tiers[0].expiration_date;

                if (expDateRaw) {
                    const today = new Date();
                    const expDate = new Date(expDateRaw);

                    today.setHours(0, 0, 0, 0);
                    expDate.setHours(0, 0, 0, 0);

                    const diffTime = expDate.getTime() - today.getTime();
                    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

                    // Inyectar días faltantes
                    if (tierDaysLeftEl) {
                        if (diffDays > 0) {
                            tierDaysLeftEl.textContent = `${diffDays} días`;
                        } else if (diffDays === 0) {
                            tierDaysLeftEl.textContent = "Hoy";
                        } else {
                            tierDaysLeftEl.textContent = "Vencido";
                        }
                    }

                    // Inyectar fecha formateada
                    if (tierExpEl) {
                        const dateFormatted = expDate.toLocaleDateString('es-PE', { year: 'numeric', month: '2-digit', day: '2-digit' });
                        tierExpEl.textContent = `El ${dateFormatted}`;
                    }
                } else {
                    if (tierDaysLeftEl) tierDaysLeftEl.textContent = "Sin límite";
                    if (tierExpEl) tierExpEl.textContent = "No expira";
                }
            }

            // 3. Lógica de cierre de sesión sincronizado
            const logoutBtn = document.getElementById('club-logout-btn');
            if (logoutBtn) {
                logoutBtn.addEventListener('click', () => {
                    sessionStorage.clear();
                    localStorage.removeItem('club_brillo_session');
                });
            }
            
            await loadPromotionsLogic(userId, currentPoints, userEmail);

            if(globalLoader) {
                setTimeout(() => {
                    globalLoader.classList.add('hidden');
                    // Forzar el scroll hacia la parte superior
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                }, 500);
            }

        } catch (error) {
            console.error("❌ Error crítico Club:", error);

            if(globalLoader) {
                globalLoader.innerHTML = `
                    <div class="error-container">
                        <p style="color: #e6107d; font-size: 1.2rem; margin-bottom: 10px;">⚠️ Ocurrió un problema</p>
                        <p class="loader-text">No pudimos cargar tu información.</p>
                        <p style="font-size: 0.9rem; color: #666;">${error.message || 'Error de conexión'}</p>
                        <button class="btn-retry" onclick="location.reload()">Reintentar</button>
                    </div>
                `;
            }
        }
    }

    function processHeroSection(clientTierData, globalTierList, currentPoints) {
        const userInfo = (clientTierData && clientTierData.tiers && clientTierData.tiers.length > 0) ? clientTierData.tiers[0] : null;
        const allTiers = (globalTierList && globalTierList.structures && globalTierList.structures[0]) ? globalTierList.structures[0].tiers : [];

        if (!userInfo) return 0;

        const currentTierObj = userInfo.tier;
        const nextTierObj = userInfo.next_tier;

        const tierTextEl = document.getElementById('current-tier-name');
        const heroImgEl = document.getElementById('tier-hero-image');
        const tierIconEl = document.getElementById('current-tier-icon');
        const progressFill = document.getElementById('tier-progress-fill'); 
        const nextMsgEl = document.getElementById('next-tier-message'); 

        if(tierTextEl) tierTextEl.textContent = currentTierObj.name;

        const imgUrl = currentTierObj.badge_image || currentTierObj.image;

        if (imgUrl) {
            if(heroImgEl) heroImgEl.src = imgUrl;
            if(tierIconEl) tierIconEl.src = imgUrl;
        }

        /* Sobreescribimos los banners según el dispositivo */
const isMobile = window.matchMedia('(max-width: 767px)').matches;

switch (currentTierObj.name) {

    case "Brilla":
        heroImgEl.src = isMobile
            ? 'https://cdn.shopify.com/s/files/1/0700/0952/0347/files/800x1000_nivel_brilla_mobile_copia-100.jpg?v=1789595592'
            : 'https://cdn.shopify.com/s/files/1/0700/0952/0347/files/2000x687_nivel_brilla_desktop_copia-100.jpg?v=1789595592';

        tierIconEl.src =
            'https://cdn.shopify.com/s/files/1/0700/0952/0347/files/brilla.png?v=1789599052';
        break;


    case "Estrella":
        heroImgEl.src = isMobile
            ? 'https://cdn.shopify.com/s/files/1/0700/0952/0347/files/800x1000_nivel_estrella_mobile_copia-100.jpg?v=1789595592'
            : 'https://cdn.shopify.com/s/files/1/0700/0952/0347/files/2000x687_nivel_estrella_desktop_copia-100.jpg?v=1789595592';

        tierIconEl.src =
            'https://cdn.shopify.com/s/files/1/0700/0952/0347/files/estrella.png?v=1789599052';
        break;


    case "Diamante":
        heroImgEl.src = isMobile
            ? 'https://cdn.shopify.com/s/files/1/0700/0952/0347/files/800x1000_nivel_diamante_mobile_copia-100.jpg?v=1789595592'
            : 'https://cdn.shopify.com/s/files/1/0700/0952/0347/files/2000x687_nivel_diamante_desktop_copia-100.jpg?v=1789595592c';

        tierIconEl.src =
            'https://cdn.shopify.com/s/files/1/0700/0952/0347/files/diamante.png?v=1789599052';
        break;
}


        const domSteps = document.querySelectorAll('#tier-steps-container .tier-step');
        const currentTierId = currentTierObj.unique_id || currentTierObj._id;
        let currentTierIndex = -1;

        if (allTiers.length > 0) {
            currentTierIndex = allTiers.findIndex(t => t.unique_id === currentTierId || t._id === currentTierId);
            
            domSteps.forEach((stepEl, index) => {
                const tierData = allTiers[index];
                if (!tierData) return;

                const spanStep = stepEl.querySelector('span');
                if (spanStep) spanStep.textContent = tierData.name;

                if (index <= currentTierIndex) {
                    stepEl.classList.add('active');
                } else {
                    stepEl.classList.remove('active');
                }
            });
        }

        const oldActiveCells = document.querySelectorAll('.active-tier-column');
        oldActiveCells.forEach(cell => cell.classList.remove('active-tier-column'));

        if (currentTierIndex > -1) {
            const cssColumnIndex = currentTierIndex + 2;

            const cellsToHighlight = document.querySelectorAll(
                `.club-table th:nth-child(${cssColumnIndex}), .club-table td:nth-child(${cssColumnIndex})`
            );

            cellsToHighlight.forEach(cell => {
                cell.classList.add('active-tier-column');
            });
        }

        let progressPercent = 0;
        if (!nextTierObj) {
            progressPercent = 100;
            if(nextMsgEl) nextMsgEl.textContent = "¡Has alcanzado el nivel máximo!";
        } else {
            const totalSegments = Math.max(1, allTiers.length - 1);
            const segmentWidth = 100 / totalSegments;
            const baseProgress = (currentTierIndex > -1) ? (currentTierIndex * segmentWidth) : 0;
            const currentLevelFloor = (currentTierIndex > -1) ? allTiers[currentTierIndex].threshold : 0;
            const range = nextTierObj.threshold - currentLevelFloor;
            const gained = currentPoints - currentLevelFloor;

            let relativePercent = 0;
            if (range > 0) {
                relativePercent = (gained / range) * segmentWidth;
            }
            progressPercent = baseProgress + relativePercent;

            if(nextMsgEl) {
                const missing = nextTierObj.threshold - currentPoints;
                if (missing > 0 ) {
                    nextMsgEl.innerHTML = `Te faltan <strong>${missing}</strong> pts para ser ${nextTierObj.name}`;
                }
            }
        }

        if(progressPercent > 100) progressPercent = 100;
        if(progressPercent < 0) progressPercent = 0;
        
        if(progressFill) progressFill.style.width = `${progressPercent}%`;

        return currentPoints;
    }

    async function loadPromotionsLogic(userId, userPoints, userEmail) {
        try {
            const data = await fetchAPI('promotions', { user_id: userId });
            const promos = data.promos || [];

            const discountsTrack = document.getElementById('discounts-track');
            const missionsTrack = document.getElementById('missions-track');
            const template = document.getElementById('card-template');

            if(!discountsTrack || !missionsTrack || !template) return;

            discountsTrack.innerHTML = '';
            missionsTrack.innerHTML = '';

            if(promos.length === 0) {
                discountsTrack.innerHTML = '<p class="empty-msg">No hay promociones.</p>';
                return;
            }

            let hasDiscounts = false;
            let hasMissions = false;

            promos.forEach((promo, index) => {
                const categories = promo.category || [];
                const isDiscount = categories.includes('promo-dest');
                const isMission = categories.includes('mensuales');

                if (!isDiscount && !isMission) return;

                let targetContainer = null;
                if (false) { 
                    targetContainer = missionsTrack;
                    hasMissions = true;
                } else {
                    targetContainer = discountsTrack;
                    hasDiscounts = true;
                }

                const clone = template.content.cloneNode(true);
                const cardDiv = clone.querySelector('.club-card');
                const titleEl = clone.querySelector('.card-title');
                if(titleEl) titleEl.textContent = promo.name;
                
                let imageUrl = 'https://cdn.shopify.com/s/files/1/0564/2787/2415/files/placeholder-promo.png';
                if (promo.images && promo.images.length > 0 && promo.images[0].url) {
                    imageUrl = promo.images[0].url;
                }

                let imgContainer = clone.querySelector('.card-image');
                if(!imgContainer) {
                    imgContainer = document.createElement('div');
                    imgContainer.className = 'card-image';
                    cardDiv.insertBefore(imgContainer, cardDiv.firstChild);
                }
                
                imgContainer.innerHTML = `<img src="${imageUrl}" alt="${promo.name}" style="width:100%; height:100%; object-fit:cover;">`;
                
                imgContainer.style.width = '250px';
                imgContainer.style.backgroundColor = '#f4f4f4';

                const btn = clone.querySelector('.btn-club'); 
                const revealArea = clone.querySelector('.code-reveal');
                
                if (btn) {
                    const cost = promo.points || 0;
                    const isLocked = promo.visibility === false; 

                    if (isLocked) {
                        btn.textContent = "BLOQUEADO";
                        btn.disabled = true;
                        btn.style.backgroundColor = '#999';
                        btn.style.cursor = 'not-allowed';
                        imgContainer.style.opacity = '0.6';
                    } 
                    else if (userPoints < cost) {
                        btn.textContent = `Faltan ${cost - userPoints} pts`;
                        btn.disabled = true;
                        btn.style.backgroundColor = '#eee';
                        btn.style.color = '#999';
                        btn.style.cursor = 'not-allowed';
                    } 
                    else {
                        btn.textContent = "CANJEAR CUPÓN";
                        
                        btn.onclick = async () => {
                            const originalText = btn.textContent;
                            btn.textContent = "Procesando...";
                            btn.disabled = true;

                            try {
                                const payload = {
                                    email: userEmail,
                                    user_id: userId,
                                    promo_id: promo._id
                                };

                                const res = await fetchAPI('redeem', payload, 'POST');

                                if (res && res.status === 'success') {
                                    let code = "CÓDIGO";
                                    if (res.data.redeems && res.data.redeems[0]) code = res.data.redeems[0].code;
                                    else if (res.data.code) code = res.data.code;
                                    else if (res.data.coupon_code) code = res.data.coupon_code;

                                    btn.style.display = 'none';
                                    if (revealArea) {
                                        revealArea.style.display = 'block';
                                        revealArea.textContent = code;
                                        revealArea.style.border = '2px dashed #e6107d';
                                        revealArea.style.color = '#e6107d';
                                        revealArea.style.padding = '10px';
                                        revealArea.style.textAlign = 'center';
                                        revealArea.style.fontWeight = 'bold';
                                    }
                                    
                                    const pDisplay = document.getElementById('user-points');
                                    if (pDisplay) {
                                        const newPoints = Math.max(0, userPoints - cost);
                                        pDisplay.textContent = newPoints;
                                        userPoints = newPoints;
                                    }

                                } else {
                                    let errorReason = "Error desconocido al canjear";

                                    if (res && res.message) {
                                        if (typeof res.message === 'object') {
                                            errorReason = res.message.reason || JSON.stringify(res.message);
                                        } else {
                                            errorReason = res.message;
                                        }
                                    }
                                    
                                    throw new Error(errorReason);
                                }

                            } catch (e) {
                                console.error("Error Canje:", e);
                                btn.innerText = originalText;
                                btn.disabled = false;
                                
                                let msgToShow = e.message;

                                if (msgToShow === "[object Object]") {
                                    msgToShow = "No cumples con los requisitos para esta promoción.";
                                }

                                alert("No se pudo canjear: " + msgToShow);
                            }
                        };
                    }
                }

                if(targetContainer) targetContainer.appendChild(clone);
            });

            if(!hasDiscounts) discountsTrack.innerHTML = '<p class="empty-msg" style="padding:20px;">No hay descuentos.</p>';

        } catch (e) {
            console.error("Error cargando promociones:", e);
            throw e;
        }
    }

    async function fetchAPI(scope, params = {}, method = 'GET') {
        const rootUrl = (window.ShopifyRoutes && window.ShopifyRoutes.root) ? window.ShopifyRoutes.root : '/';
        const proxyUrl = `${rootUrl}apps/apolo-loyalty`; 
        
        let url = proxyUrl;
        let options = { method: method, headers: { 'Content-Type': 'application/json' } };

        if (method === 'GET') {
            const queryString = new URLSearchParams({ scope, ...params }).toString();
            url = `${proxyUrl}?${queryString}`;
        } else {
            options.body = JSON.stringify({ scope, ...params });
        }

        const response = await fetch(url, options);
        
        const contentType = response.headers.get("content-type");
        let data = null;
        if (contentType && contentType.indexOf("application/json") !== -1) {
            data = await response.json();
        }

        if (!response.ok) {
            let errorMsg = `Error ${response.status}`;

            if (data && data.message) {
                if (typeof data.message === 'object') {
                    errorMsg = data.message.reason || data.message.error || JSON.stringify(data.message);
                } else {
                    errorMsg = data.message;
                }
            }
            
            throw new Error(errorMsg);
        }

        return data;
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initLoyaltyManager);
    } else {
        initLoyaltyManager();
    }

})();

/**
 * AUTO-LOGOUT POR INACTIVIDAD (1 HORA)
 */
(function() {
    let inactivityTimer;
    const TIME_LIMIT = 60 * 60 * 1000; 

    function logoutUser() {
        console.warn("⏳ 1 hora de inactividad detectada. Cerrando sesión...");
        sessionStorage.clear();
        localStorage.removeItem('club_brillo_session');
        window.location.href = '/account/logout';
    }

    function resetTimer() {
        clearTimeout(inactivityTimer);
        inactivityTimer = setTimeout(logoutUser, TIME_LIMIT);
    }

    window.addEventListener('mousemove', resetTimer);
    window.addEventListener('click', resetTimer);
    window.addEventListener('keypress', resetTimer);
    window.addEventListener('scroll', resetTimer);

    resetTimer();
})();

/**
 * Mueve el slider horizontalmente
 */
window.moveSlider = function(trackId, direction) {
    const track = document.getElementById(trackId);
    
    if (!track) return;

    const card = track.querySelector('.club-card');
    const cardWidth = card ? card.offsetWidth : 300; 
    const gap = 20;
    
    const scrollAmount = cardWidth + gap;

    if (direction === 'left') {
        track.scrollBy({
            left: -scrollAmount,
            behavior: 'smooth'
        });
    } else {
        track.scrollBy({
            left: scrollAmount,
            behavior: 'smooth'
        });
    }
};